import { CKEditor } from '@ckeditor/ckeditor5-react'
// @ts-expect-error -- ckeditor5-build-classic no expone tipos TS, lo casteamos como any abajo.
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

interface Props {
  value: string
  onChange: (html: string) => void
  placeholder?: string
  minHeight?: number
}

/**
 * Editor visual WYSIWYG basado en CKEditor 5 Classic.
 * Devuelve HTML por `onChange`. Usar para campos rich-text del admin
 * (content de páginas, posts, FAQs, descripción producto, body de emails…).
 */
export function RichEditor({ value, onChange, placeholder, minHeight = 300 }: Props) {
  return (
    <div
      className="ck-wrapper"
      style={{ ['--ck-min-height' as any]: `${minHeight}px` } as React.CSSProperties}
    >
      <CKEditor
        // El build clásico es un constructor JS sin tipos publicados — el wrapper lo acepta.
        editor={ClassicEditor as any}
        data={value}
        config={{
          placeholder,
          toolbar: {
            items: [
              'heading',
              '|',
              'bold',
              'italic',
              'underline',
              'link',
              '|',
              'bulletedList',
              'numberedList',
              '|',
              'blockQuote',
              'insertTable',
              '|',
              'undo',
              'redo',
              '|',
              'sourceEditing',
            ],
          },
          // Uso open source — no requiere license key.
          licenseKey: 'GPL',
        }}
        onChange={(_evt, editor) => onChange(editor.getData())}
      />
    </div>
  )
}
